import { BaseRouteService } from "./BaseRouteService";

type CheckPuzzleResponse = {
    correct: boolean;
};

export class PuzzleService extends BaseRouteService {
    private api_url: string = "puzzel";

    public async checkPuzzle(puzzle: string): Promise<boolean> {
        try {
            const response: CheckPuzzleResponse = await this.getJsonApi<CheckPuzzleResponse>(`${this.api_url}/check-puzzel/${puzzle}`);
            return response.correct;
        }
        catch (error) {
            console.error("Error checking puzzle:", error);
            return false;
        }
    }
}
